import { IStore } from "../../DataTypes/storeTypes";
import { StripeState } from "../../DataTypes/stripeTypes";
import { updateState } from "../../Actions/stripeActions";
import StripeWrapper from "./StripeWrapper";
import { SimpleDialog } from "@powerdiary/components-library/lib";
import { useDispatch, useSelector } from "react-redux";

export const StripeModal = () => {
    const state = useSelector((state: IStore) => state.stripe.stripeState);
    const dispatch = useDispatch();

    const onModalClosed = () => {
        dispatch(updateState(StripeState.None));
    };

    if (state === StripeState.None) return null;

    return (
        <SimpleDialog
            open
            dialogTitleText="Securely store your card details"
            renderContent={() => <StripeWrapper />}
            handleClose={onModalClosed}
        />
    );
};
